import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import Swiper from 'swiper';

@Component
export class ShopTheLookHotspots extends ThemeComponent {
    @Ref() hotspotButton!: HTMLButtonElement[];
    @Prop({ default: -1 }) optionIndex!: number;

    private _onSwiperInit = new SimpleEvent<Swiper>();
    get onSwiperInit() {
        return this._onSwiperInit.asEvent();
    }

    // Map to store Swiper instances per look block
    swipers = new Map<HTMLElement, Swiper>();

    init() {

        for (const button of this.hotspotButton) {
            this.$listen(button, 'click', () => {
                const hotspotButtons = document.querySelectorAll('.shop-the-look-hotspots__trigger');
                for (const bttn of hotspotButtons) {
                    bttn.classList.remove('active');
                }
                // Add 'active' class only to the clicked button
                button.classList.add('active');
                const buttonId = button.getAttribute("data-id");
                this.handleOnHotspot(button, buttonId);
            });
        }
    }

    handleOnHotspot(button: HTMLButtonElement, buttonId: string | null) {
        if (!buttonId) { return; }

        // Find the closest .shop-look__popup-content parent
        const parentDiv = button.closest('.shop-content-js') as HTMLElement;

        if (parentDiv) {
            // Find or initialize the Swiper instance within this specific popup
            const sliderElement = parentDiv.querySelector<HTMLElement>('.product-slider-js');

            if (sliderElement) {
                let swiperInstance = this.swipers.get(sliderElement);

                // Initialize Swiper if not already initialized for this slider
                if (!swiperInstance) {
                    swiperInstance = new Swiper(sliderElement, {
                        navigation: {
                            nextEl: parentDiv.querySelector('.swiper-next') as HTMLElement,
                            prevEl: parentDiv.querySelector('.swiper-prev') as HTMLElement,
                        },
                        pagination: true,
                        slidesPerView: 1.15,
                        spaceBetween: 8,
                        speed: 300,
                        breakpoints: {
                            425: {
                                slidesPerView: 1.5,
                                spaceBetween: 12,
                            },
                            768: {
                                slidesPerView: 1,
                                spaceBetween: 64,
                            },
                        },
                    });
                    this.swipers.set(sliderElement, swiperInstance);
                    this._onSwiperInit.dispatch(swiperInstance); // Emit the Swiper instance

                    swiperInstance.on('slideChange', () => {
                        if(swiperInstance) {
                            this.updateNavigationButtons(swiperInstance, parentDiv);
                        }
                    });
                }

                swiperInstance.update();

                // Find the target slide and ensure animation plays
                const slides = Array.from(swiperInstance.slides) as HTMLElement[];
                const targetSlide = slides.find((slide) => slide.getAttribute("data-ref") === buttonId);

                if (targetSlide) {
                    const targetIndex = slides.indexOf(targetSlide);
                    swiperInstance.slideTo(targetIndex, 300);
                    this.updateNavigationButtons(swiperInstance, parentDiv);
                } else {
                    return;
                }
            }
        }
    }

    updateNavigationButtons(swiperInstance: Swiper, parentDiv: HTMLElement) {
        const prevButton = parentDiv.querySelector('.swiper-prev') as HTMLButtonElement;
        const nextButton = parentDiv.querySelector('.swiper-next') as HTMLButtonElement;

        if (prevButton) {
            if (swiperInstance.isBeginning) {
                prevButton.classList.add('swiper-button-disabled');
                prevButton.disabled = true;
            } else {
                prevButton.classList.remove('swiper-button-disabled');
                prevButton.disabled = false;
            }
        }

        if (nextButton) {
            if (swiperInstance.isEnd) {
                nextButton.classList.add('swiper-button-disabled');
                nextButton.disabled = true;
            } else {
                nextButton.classList.remove('swiper-button-disabled');
                nextButton.disabled = false;
            }
        }
    }
}
